import { StyleSheet } from "react-native";
import { addFontFamilylato } from './utils/services/CommonUtils';
import Colors from "./utils/constants/AppColors";
import { FixedHeight, FixedWidth } from "./utils/constants/ConstantsMapping";

const AppStyles = StyleSheet.create(addFontFamilylato({

    fullScreenView: {
        backgroundColor: Colors.white,
        width: FixedWidth.appWidth, height: FixedHeight.deviceHeight
    },
    screenViewWithHeader: {
        backgroundColor: Colors.white,
        marginTop: FixedHeight.headerHeight, width: FixedWidth.appWidth,
        height: FixedHeight.appHeight - FixedHeight.headerHeight
    },
    mainContainer: {
        paddingHorizontal: 16,
        paddingVertical: 16,
        backgroundColor: 'white'
    },
    modalContainer: {
        padding: 16, borderRadius: 4,
        backgroundColor: Colors.white,
        width: FixedWidth.appWidth - 32, margin: "auto"
    },

    header: {
        flex: 1, position: 'fixed', zIndex: 10, elevation: 8,
        flexDirection: "row", alignContent: 'space-between', justifyContent: "space-between",
        alignItems: 'center', textAlign: 'center', textAlignVertical: "center",
        borderBottomColor: Colors.grey.border, shadowColor: Colors.grey.shadowColor,
        shadowOpacity: 0.6, shadowRadius: 8, borderBottomWidth: 1, backgroundColor: 'white',
        paddingVertical: 12, width: FixedWidth.appWidth, minHeight: FixedHeight.headerHeight,
    },
    localityHeader: {
        flex: 1,
        position: 'fixed',
        textAlign: 'center',
        textAlignVertical: "center",
        zIndex: 10,
        borderBottomColor: Colors.grey.border,
        shadowColor: Colors.grey.shadowColor,
        shadowOpacity: 0.6,
        shadowRadius: 8,
        borderBottomWidth: 1,
        paddingVertical: 12,
        width: FixedWidth.appWidth,
        backgroundColor: 'white',
        elevation: 8,
    },

    flexRow: {
        flexDirection: "row",
        alignItems: 'center'
    },
    flexRowCenter: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    flexRowSpaceBetween: {
        flexDirection: "row",
        alignContent: 'space-between',
        justifyContent: "space-between",
        alignItems: 'center',
    },
    flexRowSpaceEvenly: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "space-evenly",
        alignItems: 'center'
    },
    flexRowSpaceAround: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "space-around",
        alignItems: 'center'
    },
    flexRowEnd: {
        flexDirection: "row",
        alignItems: "center",
        alignContent: "flex-end",
        justifyContent: "flex-end",
    },
    flexRowStart: {
        flexDirection: "row",
        alignItems: "center",
        alignContent: "flex-start",
        justifyContent: "flex-start",
    },

    alignCenter: {
        alignSelf: "center",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center"
    },
    alignItemCenter: {
        alignSelf: "center",
        alignItems: "center",
    },
    alignItemStart: {
        alignSelf: "flex-start",
        alignItems: "flex-start",
    },

    lightShadow: {
        shadowColor: Colors.grey.shadowColor,
        zIndex: 4, shadowOpacity: 0.1, shadowRadius: 6,
        shadowOffset: { height: 1, width: 1 }
    },
    mediumShadow: {
        shadowColor: Colors.grey.shadowColor,
        zIndex: 4, shadowOpacity: 0.2, shadowRadius: 6,
        shadowOffset: { height: 1, width: 1 }
    },
    darkShadow: {
        shadowColor: Colors.grey.shadowColor,
        zIndex: 8, shadowOpacity: 0.6, shadowRadius: 10,
        shadowOffset: { height: 1, width: 1 }
    },

    border4: { borderRadius: 4 },
    border12: { borderRadius: 12 },

    borderView: {
        borderColor: Colors.grey.border,
        borderRadius: 12, borderWidth: 1
    },
    borderViewPrimary: {
        borderColor: Colors.primary,
        borderRadius: 12, borderWidth: 1
    },
    borderViewRound: {
        borderRadius: "50%", borderWidth: 1,
        borderColor: Colors.grey.border
    },
    bottomBorderView: {
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
        borderColor: Colors.grey.border,
        borderWidth: 1, backgroundColor: Colors.white
    },
    topBorderView: {
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        borderColor: Colors.grey.border,
        borderWidth: 1, backgroundColor: Colors.white
    },

    bottomFix: {
        position: 'fixed', bottom: 0, zIndex: 8,
        margin: 'auto', width: FixedWidth.appWidth,
    },
    topFix: {
        position: 'fixed', top: 0, zIndex: 8,
        margin: 'auto', width: FixedWidth.appWidth,
    },
    positionFixed: { position: 'fixed' },

    appWidth: { width: FixedWidth.appWidth },
    appHeight: { height: FixedHeight.appHeight },

    bg: { backgroundColor: Colors.background },
    bgWhite: { backgroundColor: Colors.white },
    bgBlack: { backgroundColor: Colors.black },
    bgPrimary: { backgroundColor: Colors.primary },

    mAuto: { margin: 'auto' },
    overflowInherit: { overflow: "inherit" },

    mt4: { marginTop: 4 },
    pt4: { paddingTop: 4 },
    mr4: { marginRight: 4 },
    py4: { paddingVertical: 4 },

    py6: { paddingVertical: 6 },

    m8: { margin: 8 },
    p8: { padding: 8 },
    mt8: { marginTop: 8 },
    pt8: { paddingTop: 8 },
    pl8: { paddingLeft: 8 },
    mr8: { marginRight: 8 },
    pr8: { paddingRight: 8 },
    mb8: { marginBottom: 8 },
    pb8: { paddingBottom: 8 },
    my8: { marginVertical: 8 },
    py8: { paddingVertical: 8 },
    mx8: { marginHorizontal: 8 },
    px8: { paddingHorizontal: 8 },

    m10: { margin: 10 },
    p10: { padding: 10 },
    mt10: { marginTop: 10 },
    pr10: { paddingRight: 10 },
    mY10: { marginVertical: 10 },
    py10: { paddingVertical: 10 },
    mx10: { marginHorizontal: 10 },
    px10: { paddingHorizontal: 10 },

    mt12: { marginTop: 12 },
    mr12: { marginRight: 12 },
    my12: { marginVertical: 12 },
    py12: { paddingVertical: 12 },
    mx12: { marginHorizontal: 12 },
    px12: { paddingHorizontal: 12 },

    mr14: { marginRight: 14 },

    m16: { margin: 16 },
    p16: { padding: 16 },
    mt16: { marginTop: 16 },
    pt16: { paddingTop: 16 },
    ml16: { marginLeft: 16 },
    pl16: { paddingLeft: 16 },
    mb16: { marginBottom: 16 },
    pr16: { paddingRight: 16 },
    pb16: { paddingBottom: 16 },
    mY16: { marginVertical: 16 },
    py16: { paddingVertical: 16 },
    mx16: { marginHorizontal: 16 },
    px16: { paddingHorizontal: 16 },


    mx18: { marginHorizontal: 18 },
    px18: { paddingHorizontal: 18 },

    mt24: { marginTop: 24 },
    mb24: { marginBottom: 24 },
    mx24: { marginHorizontal: 24 },
    px24: { paddingHorizontal: 24 },

    mtHeader: { marginTop: FixedHeight.headerHeight },

    greenCircle: {
        width: 50, height: 50, borderRadius: 25,
        fontSize: 35, textAlign: "center", lineHeight: 50,
        backgroundColor: Colors.green.primary, color: Colors.white
    },

    dashedBorder: { borderStyle: 'dashed', gap: 2 },

    centerAlignedText: {
        textAlign: 'center',
    },
    centerAligned: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    rightAligned: {
        justifyContent: 'flex-end',
    },
    questionText: {
        fontSize: 16,
        fontWeight: '500',
        marginVertical: 12,
        color: Colors.black,
    },
    mdText: {
        fontSize: 16,
        color: '#b3000'
    },
    quesInput: {
        borderColor: Colors.grey.border,
        borderWidth: 1,
        borderRadius: 4,
        padding: 4,
    },
    checkbox: {
        margin: 10
    },


    submitBtn: {
        marginTop: 24
    },
    applyFont: {
        fontStyle: ''
    },
    f20: {
        fontSize: 20
    },
    f16: {
        fontSize: 16
    },
    f12: {
        fontSize: 12
    },
    f25: {
        fontSize: 25
    },
    f14: {
        fontSize: 14
    },

    inputContainer: {
        backgroundColor: Colors.background, borderRadius: 8,
        paddingVertical: 10, paddingHorizontal: 16, flexDirection: "row"
    },

}))

export const ComponentViewStyle = StyleSheet.create(addFontFamilylato({
    tabBar: {
        ...AppStyles.py16,
        ...AppStyles.bgWhite,
        ...AppStyles.mediumShadow,
        ...AppStyles.flexRowSpaceAround,
        ...AppStyles.bottomFix,
        height: FixedHeight.bottomNavBarHeight
    },
    tabComponent: {
        width: FixedWidth.appWidth,
        height: FixedHeight.deviceHeight
    },
    tabComponentWithHeader: {
        width: FixedWidth.appWidth,
        height: FixedHeight.deviceHeight,
        marginTop: FixedHeight.headerHeight
    }
}))

export default AppStyles;